import { AccountSettingsDataService } from 'app/shared/services/account-settings-data-service';
import { AuthenticationService } from 'app/core/authentication';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component } from '@angular/core';
import { DeleteAccountModal } from 'app/shared/modals/delete-account-modal/delete-account-modal';
import { FormBuilder } from '@angular/forms';
import { TranslationService } from 'app/core/internationalization/translation.service';


@Component({
    selector: 'kh-teacher-delete-account-modal',
    styleUrls: ['./teacher-delete-account-modal.component.less'],
    templateUrl: './teacher-delete-account-modal.component.html',
    standalone: false
})
export class TeacherDeleteAccountModalComponent extends DeleteAccountModal {

  public constructor(protected readonly bsModalRef: BsModalRef,
    protected readonly translationService: TranslationService,
    protected readonly formBuilder: FormBuilder,
    protected readonly accountSettingsDataService: AccountSettingsDataService,
    protected readonly authenticationService: AuthenticationService) {
    super(bsModalRef, translationService, formBuilder, accountSettingsDataService, authenticationService);
  }
}
